import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../common/icons/Icon';
import moment from 'moment-timezone';

const TIME_ZONE_ID = 'America/Phoenix';

class HistoryViewModal extends Component {
  static propTypes = {
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func,
  };

  render = () => {
    const { session, toggleModal } = this.props;

    return (
      <div>
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          <div className="booking-modal--header">
            <Icon icon="Person" />
            <h3>{session.type === 'online' ? 'Online' : 'In-Person'} Follow-Up with Tathata</h3>
          </div>
          <div className="user-info">
            <div className="admin-paper__edit-content__row">
              <p>User Name</p>
              <span className="title">{session.user.name}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>User Email Address</p>
              <span className="title">{session.user.email}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Session Status</p>
              <span className="title session-status">{session.status.replace(/_/g, ' ')}</span>
            </div>
          </div>
          {session.note && (
            <div className="booking-note">
              <i>{`"${session.note}"`}</i>
            </div>
          )}
          {session.accepted_session_date && (
            <div className="booking-times__wrapper" style={{ marginBottom: '0' }}>
              <p>Date & Time</p>
              <div className="booking-times">
                <strong>
                  {moment(session.accepted_session_date)
                    .tz(TIME_ZONE_ID)
                    .format('MMM D, YYYY h:mmA z')}
                </strong>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
}

export default HistoryViewModal;



// WEBPACK FOOTER //
// ./src/follow-ups/history/HistoryViewModal.js